module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-toolbar p-component mb-4"
  }, [_c('warehouseGroupDialog', {
    ref: "openDialog"
  })], 1), _vm._v(" "), _c('warehouseGroupList', {
    on: {
      "edit-warehouseGroup": _vm.editWarehouseGrp,
      "deleteWarehouseGroup": _vm.deletWarehouseGrp
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ea86f50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/warehouse/WarehouseGroup.vue
// module id = 2117
// module chunks = 0